import React, { useEffect, useRef, useState } from 'react';
import { OverlayEventDetail } from '@ionic/core/components';
import { IonModal } from '@ionic/react';
import { MapSVG } from '../../Global/Icons/Icons';
import {
	TrailMapContainer,
	TrailsOnMapButton,
	TraisOnMapContainer,
} from './trailsOnMapStyles';
import { CloseButton } from '../../TrailPage/VirtualTour/virtualTourStyles';
import { close } from 'ionicons/icons';
import 'swiper/css';
import 'swiper/css/free-mode';
import MapToasts from './MapToasts/MapToasts';
import { Trail } from '../../../models/Trail';
import TrailsMap from '../../MapComponents/TrailslMap';

type TrailsOnMapProps = {
	trails: Trail[];
};
const TrailsOnMap: React.FC<TrailsOnMapProps> = ({ trails }) => {
	const [isOpen, setIsOpen] = useState(false);
	const trailMap = useRef<HTMLIonModalElement>(null);
	const [activeIndex, setActiveIndex] = useState(0);
	const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
		if (ev.detail.role === 'confirm') {
		}
	};

	useEffect(() => {
		console.log('Is Open Resize Handler');
		setTimeout(() => {
			window.dispatchEvent(new Event('resize'));
		}, 100);
	}, [isOpen]);

	const closeTrailsMap = () => {
		setIsOpen(false);
	};
	return trails.length === 0 ? (
		<></>
	) : (
		<>
			<TraisOnMapContainer>
				<TrailsOnMapButton
					onClick={() => setIsOpen(true)}>
					<MapSVG />
					Open Trail Map
				</TrailsOnMapButton>
			</TraisOnMapContainer>

			<IonModal
				isOpen={isOpen}
				ref={trailMap}
				onWillDismiss={(ev: CustomEvent<OverlayEventDetail>) =>
					onWillDismiss(ev)
				}
				keepContentsMounted={true}>
				<TrailMapContainer>
					{isOpen && (
						<TrailsMap
							trails={trails}
							activeIndex={activeIndex}
							isVisible={isOpen}
						/>
					)}
				</TrailMapContainer>
				<div>
					<MapToasts
						trails={trails}
						setActiveIndex={setActiveIndex}
						onSelectTrail={closeTrailsMap}
					/>
				</div>
				<CloseButton onClick={closeTrailsMap} icon={close} />
			</IonModal>
		</>
	);
};

export default TrailsOnMap;
